{
  "familyId": "TOPO-EU-RIVIEREN",
  "questions": [
    {
      "id": "TOPO-EU-RIVIEREN-001",
      "familyId": "TOPO-EU-RIVIEREN",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_rivieren_eu",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door Parijs?",
      "options": [
        "De Seine",
        "De Rijn",
        "De Donau",
        "De Theems"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_rivieren_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Europese rivieren en steden",
            "content": "Seine → Parijs. Theems → Londen. Rijn → Keulen, Rotterdam. Donau → Wenen, Boedapest. Tiber → Rome.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivieren_seine",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De Seine stroomt door Parijs. De Eiffeltoren staat aan de oever van de Seine. De rivier mondt uit in het Kanaal (La Manche).",
        "solutionSteps": [
          "Seine → Parijs",
          "Stroomt door het hart van de stad",
          "Mondt uit in het Kanaal"
        ],
        "distractorExplanations": {
          "0": "Goed! De Seine stroomt door Parijs.",
          "1": "De Rijn stroomt door Duitsland en Nederland, niet door Parijs.",
          "2": "De Donau stroomt door Wenen en Boedapest, niet door Parijs.",
          "3": "De Theems stroomt door Londen, niet door Parijs."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-001-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Rijn"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-001-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Donau"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-001-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Theems"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-RIVIEREN-002",
      "familyId": "TOPO-EU-RIVIEREN",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_rivieren_eu",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door de meeste hoofdsteden van Europa?",
      "options": [
        "De Donau",
        "De Rijn",
        "De Seine",
        "De Wolga"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_rivieren_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Donau",
            "content": "De Donau stroomt door 4 hoofdsteden: Wenen, Bratislava, Boedapest en Belgrado — meer dan elke andere Europese rivier. De Donau is ~2850 km lang. De Wolga is langer maar stroomt alleen door Rusland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivieren_donau",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De Donau stroomt door 4 hoofdsteden: Wenen (Oostenrijk), Bratislava (Slowakije), Boedapest (Hongarije) en Belgrado (Servië). Het is de langste rivier die door meerdere EU-landen stroomt.",
        "solutionSteps": [
          "Donau = langste rivier door meerdere hoofdsteden",
          "Wenen → Bratislava → Boedapest → Belgrado",
          "~2850 km lang"
        ],
        "distractorExplanations": {
          "0": "Goed! De Donau stroomt door 4 hoofdsteden.",
          "1": "De Rijn is belangrijk maar stroomt niet door hoofdsteden (wel door Keulen en Rotterdam).",
          "2": "De Seine stroomt alleen door Frankrijk (Parijs).",
          "3": "De Wolga is de langste rivier van Europa, maar stroomt alleen door Rusland — niet door meerdere hoofdsteden."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-002-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Rijn"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-002-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Seine"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-002-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Wolga"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-RIVIEREN-003",
      "familyId": "TOPO-EU-RIVIEREN",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_rivieren_eu",
      "questionType": "multiple_choice",
      "question": "De Rijn is een belangrijke rivier voor Nederland. Waar ontspringt de Rijn?",
      "options": [
        "In de Alpen (Zwitserland)",
        "In de Pyreneeën (Spanje)",
        "In Scandinavië (Noorwegen)",
        "In Groot-Brittannië"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_rivieren_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Rijn",
            "content": "De Rijn ontspringt in de Zwitserse Alpen en stroomt door Zwitserland, Duitsland en Nederland naar de Noordzee. In Nederland splitst de Rijn in de Waal, Lek en IJssel.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivieren_rijn",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De Rijn ontspringt in de Zwitserse Alpen en stroomt ~1230 km door Zwitserland, Duitsland en Nederland naar de Noordzee.",
        "solutionSteps": [
          "Rijn ontspringt in de Alpen (Zwitserland)",
          "Stroomt door Zwitserland → Duitsland → Nederland",
          "Mondt uit in de Noordzee"
        ],
        "distractorExplanations": {
          "0": "Goed! De Rijn ontspringt in de Zwitserse Alpen.",
          "1": "De Pyreneeën liggen tussen Spanje en Frankrijk. Daar ontspringt de Ebro, niet de Rijn.",
          "2": "In Scandinavië ontspringen Noorse en Zweedse rivieren, niet de Rijn.",
          "3": "In Groot-Brittannië ontspringt de Theems, niet de Rijn."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-003-OPT1",
            "optionIndex": 1,
            "label": "Daar ontspringt de Ebro, niet de Rijn"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-003-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: In Scandinavië (Noorwegen)"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-003-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: In Groot-Brittannië"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-RIVIEREN-004",
      "familyId": "TOPO-EU-RIVIEREN",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_rivieren_eu",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door Londen?",
      "options": [
        "De Theems",
        "De Seine",
        "De Elbe",
        "De Maas"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_rivieren_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rivieren en hoofdsteden",
            "content": "Theems → Londen. Seine → Parijs. Elbe → Hamburg. Maas → Luik, Maastricht. Tiber → Rome.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivieren_theems",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De Theems (in het Engels: Thames) stroomt door Londen, de hoofdstad van het Verenigd Koninkrijk. Bekende bruggen over de Theems zijn de Tower Bridge en Westminster Bridge. De rivier mondt uit in de Noordzee. Een veelvoorkomende verwisseling is de Theems met de Seine — de Seine stroomt door Parijs, niet door Londen. Onthoud: Theems = Londen, Seine = Parijs.",
        "solutionSteps": [
          "Theems (Thames) = de rivier door Londen",
          "Bekende bruggen: Tower Bridge, Westminster Bridge",
          "Mondt uit in de Noordzee",
          "Onthoud: Theems = Londen, Seine = Parijs"
        ],
        "distractorExplanations": {
          "0": "Goed! De Theems stroomt door Londen.",
          "1": "De Seine en Theems worden vaak verwisseld. De Seine stroomt door Parijs (Frankrijk), de Theems door Londen (VK). Ezelsbruggetje: Seine klinkt Frans → Parijs.",
          "2": "De Elbe stroomt door Hamburg in Duitsland, niet door Londen. De Elbe is een belangrijke Duitse rivier die in de Noordzee uitmondt.",
          "3": "De Maas stroomt door België (Luik) en Nederland (Maastricht), niet door Londen. De Maas is een belangrijke rivier voor de Benelux."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-004-OPT1",
            "optionIndex": 1,
            "label": "De Seine en Theems worden vaak verwisseld"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-004-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Elbe"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-EU-RIVIEREN-004-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Maas"
          }
        ]
      }
    },
    {
      "id": "TOPO-EU-RIVIEREN-005",
      "familyId": "TOPO-EU-RIVIEREN",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_rivieren_eu",
      "questionType": "matching",
      "question": "Koppel elke rivier aan de stad waar hij doorheen stroomt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Seine",
            "right": "Parijs"
          },
          {
            "left": "Theems",
            "right": "Londen"
          },
          {
            "left": "Donau",
            "right": "Wenen"
          },
          {
            "left": "Rijn",
            "right": "Keulen"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "topo_rivieren_eu"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rivieren en steden",
            "content": "Seine → Parijs. Theems → Londen. Donau → Wenen (en Boedapest). Rijn → Keulen (en Rotterdam).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivieren_steden_match",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Elke grote Europese rivier stroomt door een bekende hoofdstad of grote stad. De Seine stroomt door Parijs (Frankrijk), de Theems door Londen (Verenigd Koninkrijk), de Donau door Wenen (Oostenrijk) en de Rijn door Keulen (Duitsland). Onthoud deze koppelingen als vaste combinaties.",
        "solutionSteps": [
          "Seine → Parijs (Frankrijk)",
          "Theems → Londen (Verenigd Koninkrijk)",
          "Donau → Wenen (Oostenrijk)",
          "Rijn → Keulen (Duitsland)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    }
  ]
}